import { useEffect, useState } from "react";
import { CompanyHolidayPreviewType } from "./AppCompanyHolidays"
import "./AppCompanyHolidays.css";
import { CompanyHoliday, CompanyHolidayType } from "winslow-core";
import { convertToLocalTimezone, getLastWeekdayOfMonth, getNthDayOfWeek } from "./companyHolidayUtils";

type AppCompanyHolidaysPreviewProps = {
    companyHolidays: CompanyHoliday[] | undefined;
}

export const AppCompanyHolidaysPreview = ({companyHolidays}: AppCompanyHolidaysPreviewProps) => {

    const [companyHolidaysPreview, setCompanyHolidaysPreview] = useState<CompanyHolidayPreviewType[] | undefined>(undefined);
    

    useEffect(() => {
        if (companyHolidays) {
            console.log("[AppCompanyHolidays] companyHolidays: ", companyHolidays);

            if (companyHolidays) {
                const holidaysProcessed = companyHolidays.map((holiday) => {
                    let thisYear: Date | null = null;
                    let nextYear: Date | null = null;

                    switch (holiday.type) {
                        case CompanyHolidayType.DATE:
                            if (holiday.date) {
                                const useDate = convertToLocalTimezone(holiday.date);
                                thisYear = new Date(useDate.getFullYear(), useDate.getMonth(), useDate.getDate());
                                nextYear = new Date(useDate.getFullYear() + 1, useDate.getMonth(), useDate.getDate());

                                console.log("[AppCompanyHolidays] holiday.date: ", holiday.date);
                                console.log("[AppCompanyHolidays] useDate: ", useDate);
                                console.log("[AppCompanyHolidays] thisYear: ", thisYear);
                                console.log("[AppCompanyHolidays] nextYear: ", nextYear);
                            }
                            break;
                        case CompanyHolidayType.NTH:
                            if (holiday.nth && holiday.dayOfWeek && holiday.month) {
                                thisYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear());
                                nextYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
                            }
                            break;
                        case CompanyHolidayType.LAST:
                            if (holiday.dayOfWeek && holiday.month) {
                                thisYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear());
                                nextYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
                            }
                            break;  
                        // case CompanyHolidayType.DAY_AFTER:
                        //     if (holiday.date) {
                        //         const nextDay = getNextDay(holiday.date);
                        //         thisYear = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate());
                        //         nextYear = new Date(nextDay.getFullYear() + 1, nextDay.getMonth(), nextDay.getDate());
                        //     }
                    }

                    return {
                        name: holiday.name,
                        thisYear: thisYear,
                        nextYear: nextYear,
                    } as CompanyHolidayPreviewType;
                })

                holidaysProcessed.sort((a, b) => {
                    if (a.thisYear && b.thisYear) {
                        return a.thisYear.getTime() - b.thisYear.getTime();
                    } else if (a.thisYear && !b.thisYear) {
                        return -1;
                    } else if (!a.thisYear && b.thisYear) {
                        return 1;
                    } else {
                        return 0;
                    }
                })

                setCompanyHolidaysPreview(holidaysProcessed);
            }
        }

    }, [companyHolidays]);

    const thisYear = new Date().getFullYear();
    const nextYear = thisYear + 1;

    return (
        <div className="app-company-holidays-grid">
            <div className="app-company-holidays-grid-header-item">Holiday</div>
            <div className="app-company-holidays-grid-header-item">{thisYear}</div>
            <div className="app-company-holidays-grid-header-item">{nextYear}</div>
        
            {companyHolidaysPreview && companyHolidaysPreview.map((holiday, index) => {
                return (
                    <>
                        <div className="app-company-holidays-grid-item">
                                {holiday.name}
                        </div>
                        <div className="app-company-holidays-grid-item">
                            
                                {holiday.thisYear ? holiday.thisYear.toLocaleDateString() : "N/A"}
                        </div>
                        <div className="app-company-holidays-grid-item">
                            
                                {holiday.nextYear ? holiday.nextYear.toLocaleDateString() : "N/A"}
                        </div>
                    </>
                )}
            )}
        </div>
    );
}